import { useState } from "react";
import {
  Button,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  InputAdornment,
  Loading,
  TextField,
} from "../../../../components";
import { InputErros, value } from "../../../../helpers";
import {
  MeuUsuarioService,
  UsuariosLocalService,
  notification,
} from "../../../../services";
import { decryptDadosUsuario, responseErros } from "../../../../utils";
import { loginValidator } from "../../../login-pdv/middlewares";

const meuUsuarioService = new MeuUsuarioService();

const ValidarPermissaoDialog = ({ dialog, pdvOnLine }) => {
  const [login, setLogin] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  const onChangeInput = (event) => {
    setLogin((prevState) => ({
      ...prevState,
      [event.target.name]: String(event.target.value).trim(),
    }));
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const limparDialog = () => {
    setLogin({});
    setShowPassword(false);
    inputErros.limpar();
  };

  const onCancelar = () => {
    limparDialog();
    dialog.onClose();
  };

  async function temPermissaoOnline(emailSenha) {
    const res = await meuUsuarioService.validarPermissao(
      emailSenha,
      dialog.permissao,
    );
    if (res.isAxiosError) {
      responseErros(res);
      return null;
    }
    return res.data === true;
  }

  async function temPermissaoOffline(emailSenha) {
    const dadosUsuarioEncrypted = await UsuariosLocalService.getByEmail(
      emailSenha.email,
    );
    if (!dadosUsuarioEncrypted) {
      notification.alertaGenericos("Usuário não disponível no modo offline");
      return null;
    }
    const dadosUsuario = decryptDadosUsuario(
      emailSenha.senha,
      emailSenha.email,
      dadosUsuarioEncrypted,
    );
    if (!dadosUsuario) {
      notification.alertaGenericos("E-mail ou senha inválido");
      return null;
    }
    const permisoes = dadosUsuario.usuario?.perfilUsuario?.permisoes ?? [];
    return permisoes.some(
      (permisao) => permisao.nome === dialog.permissao && permisao.habilitado,
    );
  }

  const onSubmitValidar = async (event) => {
    event.preventDefault();
    try {
      await loginValidator.validate(login, { abortEarly: false });
    } catch (err) {
      return inputErros.set(err);
    }
    inputErros.limpar();
    const emailSenha = { email: login.email, senha: login.senha };
    setLoading(true);
    const temPermissao = pdvOnLine
      ? await temPermissaoOnline(emailSenha)
      : await temPermissaoOffline(emailSenha);
    setLoading(false);
    if (temPermissao === null) {
      return setInputErro(["email", "senha"]);
    }
    if (!temPermissao) {
      return notification.alertaGenericos(
        `Usuário sem permissão para ${dialog.descricaoPermissao}`,
      );
    }
    limparDialog();
    dialog.onValidate();
  };

  return (
    <Dialog maxWidth="xs" fullWidth open={dialog.open} onClose={onCancelar}>
      <form onSubmit={onSubmitValidar}>
        <DialogContent>
          <CardHeader
            title="Autorização necessária"
            subheader={`Informe um usuário com permissão para ${dialog.descricaoPermissao}`}
          />
          <Grid container>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="E-mail"
                id="emailPermissao"
                name="email"
                margin="dense"
                type="text"
                autoFocus
                autoComplete="off"
                fullWidth
                onChange={onChangeInput}
                value={value.text(login.email)}
                error={inputErros.get("email")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="Senha"
                id="senhaPermissao"
                name="senha"
                margin="dense"
                type={showPassword ? "text" : "password"}
                autoComplete="new-password"
                fullWidth
                onChange={onChangeInput}
                value={value.text(login.senha)}
                error={inputErros.get("senha")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword}>
                        <i
                          className={`ph-fill ${
                            showPassword ? "ph-eye" : "ph-eye-slash"
                          }`}
                          style={{ color: "#494C62", fontSize: 18 }}
                        ></i>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="padrao"
            size="large"
            variant="contained"
            onClick={onCancelar}
            disableElevation
            fullWidth
          >
            Cancelar
          </Button>
          <Button
            color="info"
            size="large"
            variant="contained"
            type="submit"
            disabled={loading}
            disableElevation
            fullWidth
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10, color: "white" }}
            ></i>
            Autorizar
          </Button>
        </DialogActions>
      </form>
      <Loading loading={loading} />
    </Dialog>
  );
};

export default ValidarPermissaoDialog;
